import React from "react";
import ReserveFieldUsers from "@/components/reserve/ReserveFieldUsers/ReserveFieldUsers";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";

export const ReserveFormUsers: React.FC = () => {
  const { form, users, owner } = useReserveForm();
  return (
    <ReserveFieldUsers
      single={true}
      form={form}
      defaultValue={owner?.id ? [owner.id] : users}
      errors={form.formState.errors}
    />
  );
};
